import React, { useEffect, useState } from "react";
import "./ProductArea.css";
import { Carousel } from "react-bootstrap";
import {
  Apiurl,
  Encryption,
  parseData,
  secretKey,
} from "../../Pages/utils/page";
import ClipLoader from "react-spinners/ClipLoader";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";

import ProductCountdown from "../Countdown/Countdown";

const ProductArea = ({
  loading,
  smallBannerData,
  filteredProductData,
  indexForProduct,
  setIndexForProducts,
  handleInterest,
  handleBuyProduct,
  onNextClick,
  // handleAddtoFavourite,
  favouriteData,
  bannerIdData,
  hanleDeleteFavourite,
  loginToken,
}) => {
  const router = useNavigate();
  const [existData, setExistData] = useState();

  useEffect(() => {
    if (bannerIdData && favouriteData?.length) {
      const getcurrent = favouriteData?.find(
        (item) => item?.BannerId === bannerIdData
      );
      setExistData(getcurrent);
    } else {
      setExistData();
    }
  }, [favouriteData, bannerIdData]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div id="banner1">
            {/* add to my fav */}
            {/* <div className="indicator-banner" ><div className="banner-vendor" ><div className="vendor_section_top" ><div className="text-center" >
                            {existData && loginToken ?
                                loading === "fav" ?
                                    <a className="save_later_icons" title="save for later" >
                                        <ClipLoader
                                            loading
                                            size={15}
                                        />
                                    </a> :
                                    <a className="save_later_icons" title="save for later" onClick={() => hanleDeleteFavourite("topButt")}>
                                        Added to Favourite
                                    </a>
                                :
                                loading === "fav" ?
                                    <a className="save_later_icons" title="save for later" >
                                        <ClipLoader
                                            loading
                                            size={15}
                                        />
                                    </a>
                                    :
                                    loginToken ?

                                        <a className="save_later_icons" title="save for later" onClick={handleAddtoFavourite}>
                                            Add to My Favourite
                                        </a> : null
                            }

                        </div></div></div></div> */}
            <div className="vedor_relate_prod_scroll">
              {smallBannerData?.length ? (
                smallBannerData?.map((item) => {
                  const imagesArray = JSON.parse(item.Images);

                  const defaultImage = imagesArray.find((img) => img.Default);

                  const imageUrl = defaultImage
                    ? `${Apiurl()}/${defaultImage.Images}`
                    : "";

                  return (
                    <div className="top_banner_bg_01">
                      <div
                        className={
                          item?.IsProductOutOfStock === true
                            ? "row product_new_btm_spc_web pro_detail_wrapper_new_01 blur_effect"
                            : "row product_new_btm_spc_web pro_detail_wrapper_new_01 "
                        }
                      >
                        <div className="col-lg-3 col-md-3 col-sm-3 col-5">
                          <img
                            src={imageUrl}
                            onClick={() => {
                              router(`/productdetail/${Encryption(item?.Id)}`);
                            }}
                            className="w-100"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/Images/no-product-img-700.jpg";
                            }}
                          />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-7  pro_detl_lf_0">
                          <div className="pro_detail_spc_rgt">
                            <h2>{item?.ProductName}</h2>
                            <p>{item?.ProductDescription}</p>
                            <div>
                              <div className="product-timer">
                                <ProductCountdown item={item} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6 col-12 align_item_01">
                          <div className="pro_timer_mb_01">
                            <div className="pro_detail_bg">
                              <div className="pro_rgt_bg-section">
                                {item?.IsProductInOffer == false ? (
                                  <h3>
                                    Deal Price<span>₹ {item?.DealPrice}</span>
                                  </h3>
                                ) : null}
                                <h3>
                                  MRP<span>₹ {item?.Mrp}</span>
                                </h3>
                                <div className="col-lg-2 col-sm-12 col-12">
                                  {item?.IsProductOutOfStock === true ? (
                                    <input
                                      type="button"
                                      value="Out of Stock"
                                      className="common_btn_new out_stock_btn_01"
                                    />
                                  ) : (
                                    <input
                                      type="button"
                                      onClick={() => {
                                        router(
                                          `/productdetail/${Encryption(
                                            item?.Id
                                          )}`
                                        );
                                      }}
                                      value={
                                        item?.IsProductInOffer == true
                                          ? "Bid Now"
                                          : item?.IsProductInOffer == false
                                          ? "Buy Now"
                                          : item?.IsProductInOffer == null
                                          ? "Contact Us"
                                          : null
                                      }
                                      className={
                                        item?.IsProductInOffer == true
                                          ? "common_btn_new bid_now_btn_01"
                                          : item?.IsProductInOffer == false
                                          ? "common_btn_new"
                                          : item?.IsProductInOffer == null
                                          ? "common_btn_new"
                                          : null
                                      }
                                    />
                                  )}
                                  {/* </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <>
                  <h6>
                  We are currently working to bring you products from this partner. In the meantime, please use the banner scroll to find products from our other partners.
                  </h6>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductArea;
